import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IRetracementSettingsRow, IRetracementSettingsRowsSet, RetracementSettings } from 'src/app/Models/RetracementSettings';
import { CookiesService } from 'src/app/Services/cookieService';
import { DgHubClientService, RetracementSetting, RetracementSettingsRequest, RetracementTypes } from 'src/app/Services/dg-hub-client.service';
import { DrawingService } from 'src/app/Services/DrawingService';
import { settingChanges } from 'src/components/retracement-settings/retracement-settings.component';

@Component({
  selector: 'app-retracementTabs',
  templateUrl: './retracementTabs.component.html',
  styleUrls: ['./retracementTabs.component.scss']
})
export class RetracementTabsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<RetracementTabsComponent>,
    public dgCLientService: DgHubClientService,
    public drawingService: DrawingService,
    private cookieService: CookiesService
  ) { }

  ngOnInit() {
  }

  public upWaveLevels: IRetracementSettingsRow[]
  public dataUpwave: settingChanges;
  public dataDownwave: settingChanges;

  levelsChanges(data: settingChanges) {
    switch(data.settingType)
    {
      case RetracementTypes.UPWAVE:
        this.dataUpwave = data;
      break;

      case RetracementTypes.DOWNWAVE:
        this.dataDownwave = data;
      break;

    }

  }

  public selectedUpwaveSetting: IRetracementSettingsRowsSet;
  public selectedDownwaveSetting: IRetracementSettingsRowsSet;

  retracementTypes: typeof RetracementTypes = RetracementTypes;

  onConfirm(): void {
    let retracementSettings = new RetracementSettingsRequest();


    retracementSettings.viewName = null;//this.drawingService.selectedViewName;

    if(this.dataUpwave!=undefined)
    {
       retracementSettings.upwave = new RetracementSetting();
      retracementSettings.upwave.name = this.dataUpwave.settingName;
      retracementSettings.upwave.data = JSON.stringify(this.dataUpwave.data);
      retracementSettings.upwave.type = RetracementTypes.UPWAVE;
      retracementSettings.upwave.userid = this.dgCLientService.lastLogin ;
    }

    if(this.dataDownwave!=undefined)
    {
      retracementSettings.downwave = new RetracementSetting();
      retracementSettings.downwave.name = this.dataDownwave.settingName;
      retracementSettings.downwave.data = JSON.stringify(this.dataDownwave.data);
      retracementSettings.downwave.type = RetracementTypes.DOWNWAVE;
      retracementSettings.downwave.userid = this.dgCLientService.lastLogin;
    }

    this.dgCLientService.ChangeRetracementSettings(retracementSettings).then(v => {
      //console.log(v);
      this.drawingService.retracementsList = [];

      v.items.forEach(l => {
        this.drawingService.retracementsList.push(
          {
            name: l.name,
            levels: JSON.parse(l.data) as IRetracementSettingsRow[],
            type: l.type
          }
        )
      });

      // this.upWaveLevels = this.drawingService.retracementsList.find(v => {
      //   return v.name == this.drawingService.selectedActiveUpwaveRetracementSettingName
      // }).levels;



      // this.selectedDownwaveSetting = this.drawingService.retracementsList.find(v => {
      //   return v.name == this.drawingService.selectedActiveDownwaveRetracementSettingName && v.type == RetracementTypes.DOWNWAVE
      // });

      if(this.dataUpwave!=undefined)
      {
    //   this.cookieService.setCookie("selectedUpwaveRetracement", this.dataUpwave.settingName, 1000, "/");
       this.drawingService.selectedActiveUpwaveRetracementSettingName = this.dataUpwave.settingName;
      }

      if(this.dataDownwave!=undefined)
      {
      //  this.cookieService.setCookie("selectedDownwaveRetracement", this.dataDownwave.settingName, 1000, "/");
        this.drawingService.selectedActiveDownwaveRetracementSettingName = this.dataDownwave.settingName;
      }


      this.selectedUpwaveSetting = this.drawingService.retracementsList.find(v => {
        return v.name == this.drawingService.selectedActiveUpwaveRetracementSettingName && v.type == RetracementTypes.UPWAVE
      });

      this.selectedDownwaveSetting = this.drawingService.retracementsList.find(v => {
        return v.name == this.drawingService.selectedActiveDownwaveRetracementSettingName && v.type == RetracementTypes.DOWNWAVE
      });

      this.drawingService.retracementSettings.updateLevels((this.selectedUpwaveSetting)?this.selectedUpwaveSetting.levels:null, (this.selectedDownwaveSetting)?this.selectedDownwaveSetting.levels:null);

       this.drawingService.activeRetracements.redraw();
       this.dialogRef.close(true);


    });




    // this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false


    this.dialogRef.close(false);
  }

}
